"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceiveChannel = void 0;
const cancellable_1 = require("./utils/cancellable");
class ReceiveChannel {
    emitter = new EventEmitter();
    emit(message) {
        this.emitter.emit(message.endpoint, message.payload);
    }
    subscribe(channel, subscriber) {
        const listener = (value) => {
            const payload = value.payload;
            subscriber(payload);
        };
        this.emitter.addEventListener(channel, listener);
        return new cancellable_1.Cancellable(() => {
            this.emitter.removeEventListener(channel, listener);
        });
    }
    once(channel, subscriber) {
        const subscription = this.subscribe(channel, value => {
            subscription.cancel();
            subscriber(value);
        });
        return subscription;
    }
}
exports.ReceiveChannel = ReceiveChannel;
/**
 * Event emitter implementation that works in a browser, since browsers don't
 * have NodeJS's EventEmitter
 */
class EventEmitter extends EventTarget {
    emit(event, payload) {
        this.dispatchEvent(new EventEmitterEvent(event, payload));
    }
}
class EventEmitterEvent extends Event {
    payload;
    constructor(type, payload) {
        super(type);
        this.payload = payload;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhbm5lbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jaGFubmVsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLHFEQUFrRDtBQUVsRCxNQUFhLGNBQWM7SUFDUixPQUFPLEdBQUcsSUFBSSxZQUFZLEVBQUUsQ0FBQztJQUU5QyxJQUFJLENBQUMsT0FBZ0M7UUFDbkMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLFFBQVEsRUFBRSxPQUFPLENBQUMsT0FBTyxDQUFDLENBQUM7SUFDdkQsQ0FBQztJQUVELFNBQVMsQ0FBSSxPQUFlLEVBQUUsVUFBOEI7UUFDMUQsTUFBTSxRQUFRLEdBQUcsQ0FBQyxLQUFZLEVBQUUsRUFBRTtZQUNoQyxNQUFNLE9BQU8sR0FBSSxLQUE4QixDQUFDLE9BQU8sQ0FBQztZQUN4RCxVQUFVLENBQUMsT0FBTyxDQUFDLENBQUM7UUFDdEIsQ0FBQyxDQUFDO1FBQ0YsSUFBSSxDQUFDLE9BQU8sQ0FBQyxnQkFBZ0IsQ0FBQyxPQUFPLEVBQUUsUUFBUSxDQUFDLENBQUM7UUFDakQsT0FBTyxJQUFJLHlCQUFXLENBQUMsR0FBRyxFQUFFO1lBQzFCLElBQUksQ0FBQyxPQUFPLENBQUMsbUJBQW1CLENBQUMsT0FBTyxFQUFFLFFBQVEsQ0FBQyxDQUFDO1FBQ3RELENBQUMsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztJQUVELElBQUksQ0FBSSxPQUFlLEVBQUUsVUFBOEI7UUFDckQsTUFBTSxZQUFZLEdBQUcsSUFBSSxDQUFDLFNBQVMsQ0FBSSxPQUFPLEVBQUUsS0FBSyxDQUFDLEVBQUU7WUFDdEQsWUFBWSxDQUFDLE1BQU0sRUFBRSxDQUFDO1lBQ3RCLFVBQVUsQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUNwQixDQUFDLENBQUMsQ0FBQztRQUNILE9BQU8sWUFBWSxDQUFDO0lBQ3RCLENBQUM7Q0FDRjtBQXpCRCx3Q0F5QkM7QUFFRDs7O0dBR0c7QUFDSCxNQUFNLFlBQWEsU0FBUSxXQUFXO0lBQ3BDLElBQUksQ0FBSSxLQUFhLEVBQUUsT0FBVTtRQUMvQixJQUFJLENBQUMsYUFBYSxDQUFDLElBQUksaUJBQWlCLENBQUMsS0FBSyxFQUFFLE9BQU8sQ0FBQyxDQUFDLENBQUM7SUFDNUQsQ0FBQztDQUNGO0FBRUQsTUFBTSxpQkFBcUIsU0FBUSxLQUFLO0lBRzNCO0lBRlgsWUFDRSxJQUFZLEVBQ0gsT0FBVTtRQUVuQixLQUFLLENBQUMsSUFBSSxDQUFDLENBQUM7UUFGSCxZQUFPLEdBQVAsT0FBTyxDQUFHO0lBR3JCLENBQUM7Q0FDRiJ9